var _circle, _circle2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuyerSellerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.5,
    r: 20,
    fill: "#F2A863"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1359_13658",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 41
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.5,
    r: 20,
    fill: "#F2A863"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1359_13658)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26.7347,
    cy: 33.7653,
    r: 13.2653,
    fill: "#F4D1B1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -19.5918,
    y: 40.6055,
    width: 72.2449,
    height: 17.1429,
    transform: "rotate(-63.3958 -19.5918 40.6055)",
    fill: "#F4D1B1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyerSellerIcon);
export default __webpack_public_path__ + "static/media/buyer-seller-icon.f185800756ce1d840e9ea6d67dc9e786.svg";
export { ForwardRef as ReactComponent };